import DetailAccentCard, {
	DetailSectionHeading,
} from "../../../common/detail/DetailAccentCard";
import Timer from "./timer";

export default function TimerSection({ webinar, onFinish }) {
	const diffSecond = webinar.diff_second;
	if (diffSecond == null || diffSecond <= 0) {
		return null;
	}

	return (
		<DetailAccentCard
			ariaLabel="شمارش معکوس تا شروع"
			bodyClassName="p-5 md:p-6"
		>
			<DetailSectionHeading className="mb-4">
				شمارش معکوس تا شروع
			</DetailSectionHeading>
			<Timer
				diffSecond={diffSecond}
				minuteVisible={true}
				secondVisible={true}
				onFinish={onFinish}
			/>
		</DetailAccentCard>
	);
}
